import { GET_MASTER_SLAVE_SUCCESS } from 'common/Components/MasterSlave/controllers/const';
import SingletonConfig from 'utils/global';

const updateGlobalModeSite = () => (next: any) => (action: any) => {
  if (action.type === GET_MASTER_SLAVE_SUCCESS && action.masterSlave) {
    SingletonConfig.syncMasterSlave(action.masterSlave);
  }

  return next(action);
};

export default updateGlobalModeSite;
